/**
 * SDK Error Factory
 * Creates consistent error objects with logging
 */

import { SDKError, SDKErrorCode } from './lifecycle.types'

const RECOVERABLE_CODES: SDKErrorCode[] = [
  'IFRAME_LOAD_TIMEOUT',
  'INIT_FAILED',
  'ALREADY_INITIALIZED',
]

const LOG_PREFIX = '[eg]'

class SDKErrorImpl extends Error implements SDKError {
  code: SDKErrorCode
  recoverable: boolean
  context?: Record<string, unknown>

  constructor(
    code: SDKErrorCode,
    message: string,
    recoverable: boolean,
    context?: Record<string, unknown>
  ) {
    super(message)
    this.name = 'SDKError'
    this.code = code
    this.recoverable = recoverable
    this.context = context
    Object.setPrototypeOf(this, SDKErrorImpl.prototype)
  }
}

export function createSDKError(
  code: SDKErrorCode,
  message: string,
  context?: Record<string, unknown>
): SDKError {
  const recoverable = RECOVERABLE_CODES.includes(code)
  const error = new SDKErrorImpl(code, message, recoverable, context)

  console.error(`${LOG_PREFIX} ${code}: ${message}`, context || '')

  return error
}

export function isSDKError(error: unknown): error is SDKError {
  return error instanceof SDKErrorImpl
}

export { SDKErrorCode }
